"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClientReportEnvelope = createClientReportEnvelope;

var _envelope = require("./envelope.js");

var _time = require("./time.js");

/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
  const clientReportItem = [{
    type: 'client_report'
  }, {
    timestamp: timestamp || (0, _time.dateTimestampInSeconds)(),
    discarded_events
  }];
  return (0, _envelope.createEnvelope)(dsn ? {
    dsn
  } : {}, [clientReportItem]);
}